import { Turbo } from "@hotwired/turbo-rails"

Turbo.StreamActions.remove_smoothly = function () {
  this.targetElements.forEach((element) => {
    if (!element.animate || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return element.remove()

    const style = getComputedStyle(element)
    const from = {
      opacity: 1,
      height: `${element.offsetHeight}px`,
      paddingTop: style.paddingTop,
      paddingBottom: style.paddingBottom,
      marginBottom: style.marginBottom,
      borderTopWidth: style.borderTopWidth,
      borderBottomWidth: style.borderBottomWidth
    }
    const to = { opacity: 0, height: "0px", paddingTop: "0px", paddingBottom: "0px", marginBottom: "0px", borderTopWidth: "0px", borderBottomWidth: "0px" }

    element.style.overflow = "hidden"
    const animation = element.animate(
      [from, { ...from, opacity: 0, offset: 0.4 }, to],
      { duration: 400, easing: "ease-in-out", fill: "forwards" }
    )
    animation.onfinish = () => element.remove()
  })
}
